<template>
<div id="app">
    <!--
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>
    -->
    <router-view />
    <aside>
        <cookie-modal :locale='$i18n.locale' v-on:consentAccepted="acceptConsent">
            <template #body-content> {{ $t("c_text") }} <br /><span v-html="$t('c_text_two')"></span></template>
            <template #accept-btn-text>{{$t('c_accept')}}</template>
            <template #reject-btn-text>{{$t('c_nocookie')}}</template>
        </cookie-modal>
    </aside>
</div>
</template>

<script>
import {
    configureLocaleUrl
} from "@/plugins/i18n";
import {consent, wistiaCookieTracking, configurePageAnimation, configureConsent} from "@/common/utils";
import CookieModal from "@/components/CookieModal.vue";

export default {
    components: {
        "cookie-modal": CookieModal,
    },
    created(){
        configureConsent(consent);
        configureLocaleUrl(this);
    },
    mounted() {
        configurePageAnimation();
    },
    unmounted() {},
    methods: {
        acceptConsent() {
            consent.setStatus(true);
            //  console.log("Login::consent status is: " + consent.status)
            wistiaCookieTracking(true);
        },
    },
};
</script>

<style lang="scss">
@import "./src/assets/styles/app.scss";
</style>
